import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Head } from 'vite-react-ssg';
import { blogPosts } from '../constant/blogPosts';

const PAGE_SIZE = 10;

const Blog = () => {
  const [visible, setVisible] = useState(PAGE_SIZE);

  return (
    <div className="container mx-auto mt-16 max-w-4xl px-6 md:px-10">
      <Head>
        <title>
          Blog Kolam Renang Bali | Tips Perawatan &amp; Chemical Pool
        </title>
        <meta
          name="description"
          content="Tips perawatan kolam renang, panduan chemical pool, dan informasi terkini seputar swimming pool di Bali. Dibuat oleh tim ahli Surya Jaya Teknik."
        />
        <link rel="canonical" href="https://poolshopsuryajayateknik.com/blog" />
        <meta
          property="og:title"
          content="Blog Kolam Renang Bali | Tips Perawatan & Chemical Pool"
        />
        <meta
          property="og:description"
          content="Tips perawatan kolam renang, panduan chemical pool, dan informasi terkini seputar swimming pool di Bali."
        />
        <meta
          property="og:url"
          content="https://poolshopsuryajayateknik.com/blog"
        />
        <meta property="og:type" content="website" />
      </Head>

      <h1 className="text-3xl font-bold text-green-600 mb-2">
        Blog Kolam Renang Bali
      </h1>
      <p className="text-gray-500 mb-10">
        Tips, panduan, dan informasi seputar perawatan swimming pool di Bali
      </p>

      <div className="grid sm:grid-cols-2 gap-8">
        {blogPosts.slice(0, visible).map((post) => (
          <Link
            key={post.slug}
            to={`/blog/${post.slug}`}
            className="group block rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition"
          >
            <img
              src={post.imgSrc}
              alt={`${post.title} - Blog Pool Bali`}
              className="w-full h-48 object-cover"
            />
            <div className="p-5">
              <p className="text-xs text-gray-400 mb-2">{post.date}</p>
              <h2 className="text-lg font-bold text-gray-800 group-hover:text-green-600 transition leading-snug mb-3">
                {post.title}
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                {post.excerpt ||
                  post.content.substring(0, 120).replace(/\s+/g, ' ').trim()}
                …
              </p>
              <span className="inline-block mt-4 text-xs font-semibold text-green-600 underline">
                Read more →
              </span>
            </div>
          </Link>
        ))}
      </div>

      {visible < blogPosts.length && (
        <div className="text-center mt-10">
          <button
            onClick={() => setVisible((v) => v + PAGE_SIZE)}
            className="px-8 py-3 rounded-full border-2 border-green-600 text-green-600 font-semibold hover:bg-green-600 hover:text-white transition text-sm min-h-[44px]"
          >
            Load More ({blogPosts.length - visible} remaining)
          </button>
        </div>
      )}
    </div>
  );
};

export default Blog;
